var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shroud-white"},[_c('spinner',{staticClass:"vue-simple-spinner",attrs:{"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }